import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./Locals/en.json";
import ta from "./Locals/ta.json";

const resources = {
  en: { translation: en },
  ta: { translation: ta }
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  }
});

export default i18n;